<template>
  <a
    class="m-tabbar-item"
    :class="{ 'is-active': isActive }"
    @click="goToRouter"
    @mouseover="hover(id)"
    @mouseleave="hover_leave(id)"
  >
    <span class="m-tabbar-item-icon" v-show="!isActive"
      ><slot name="icon-normal"></slot
    ></span>
    <span class="m-tabbar-item-icon" v-show="isActive"
      ><slot name="icon-active"></slot
    ></span>
    <span
      class="m-tabbar-item-text"
      v-show="isActive"
      :style="[
        { backgroundColor: id === 'about' ? '#363C47' : '' },
        { width: id === 'home' ? '52px' : '' }
      ]"
    ></span>
    <span
      class="m-tabbar-item-text_next"
      ref="myHover"
      v-show="Hover === id"
      :style="[
        { backgroundColor: isActive_text === 'group' ? '#363C47' : '' },
        { width: id === 'home' ? '52px' : '' }
      ]"
    ></span>
  </a>
</template>
<script>
export default {
  props: {
    id: {
      type: String
    },
    isRouter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Hover: ""
    };
  },
  computed: {
    isActive() {
      if (this.$parent.value === this.id) {
        return true;
      }
    },
    isActive_text() {
      switch (this.$parent.value) {
        case "home":
          return "about";
          break;
        case "about":
          return "group";
          break;
        case "group":
          return "product";
          break;
        case "product":
          return "recruit";
          break;
        case "series":
          return "series";
          break;
        case "recruit":
          return "";
          break;
        default:
          return "";
      }
    }
  },
  methods: {
    goToRouter() {
      console.log(this.isActive_text);
      this.$parent.$emit("input", this.id);
      // 判断是否为路由跳转
      if (this.isRouter) {
        // 根据id跳转到对应的路由页面
        this.$router.push(this.id);
        this.hover();
      }
    },
    hover(id) {
      if (!this.isActive) this.Hover = id;
    },
    hover_leave() {
      this.Hover = "";
    }
  }
};
</script>
<style lang="less">
.m-tabbar {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  width: 780px;
  .m-tabbar-item {
    margin-left: 48px;
    .m-tabbar-item-icon {
      display: block;
      padding-top: 2px;
      img {
        height: 28px;
      }
    }
    .m-tabbar-item-text {
      display: block;
      position: relative;
      z-index: -11;
      top: -12px;
      width: 80px;
      height: 7px;
      background-color: #fff;
    }
    .m-tabbar-item-text_next {
      display: block;
      position: relative;
      z-index: -11;
      top: -12px;
      width: 80px;
      opacity: 0.5;
      height: 7px;
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar-item.vue